const Statistics = {
	namespaced: true,
	state: {
		statistics: '',
	},
	getters: {
		statistics(state) {
			return state.statistics;
		},
	},
	mutations: {
		storeStatistics(state, statistics) {
			state.statistics = statistics;
		},
	},
	actions: {
		saveStatistics({ commit }, statistics) {
			commit('storeStatistics', statistics);
		},
	},
};

export default Statistics;
